import { ROOM_TYPE_COMBINED } from "@Pages/Search/components/FilterSection/data/filtersList";

const getCurrentFilterName = (filterName: string, currFilters: any) => {
  if (filterName === "sortKey") {
    return "";
  }

  if (filterName === "dualOccupancy" && currFilters["dualOccupancy"]) {
    return "Dual Occupancy";
  }

  if (filterName === "moveInMonth") {
    return currFilters?.[filterName]?.replace("-", ", ");
  }

  if (filterName === "roomType") {
    const combinedRoomTypes: any =
      ROOM_TYPE_COMBINED.reduce(
        // @ts-ignore
        (acc, curr) => [...acc, ...(curr.list || [])],
        [],
      ) || [];

    return (currFilters?.[filterName] || [])?.reduce((acc: string, curr: string) => {
      const name = combinedRoomTypes.find((f: any) => f.value === curr)?.name || "";
      return `${acc} ${acc === "" ? "" : "+"} ${name}`;
    }, "");
  }
  
  if (currFilters?.[filterName] === "all_selected") {
    return "";
  }
  return currFilters?.[filterName] == "46 weeks" ? "45+ weeks" : currFilters?.[filterName] || "";
};

export default getCurrentFilterName;
